import { render, staticRenderFns } from "./StudentModal.vue?vue&type=template&id=e189c7dc&scoped=true"
import script from "./StudentModal.vue?vue&type=script&lang=js"
export * from "./StudentModal.vue?vue&type=script&lang=js"
import style0 from "./StudentModal.vue?vue&type=style&index=0&id=e189c7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e189c7dc",
  null
  
)

export default component.exports